import { g as a } from "./index-DUTDaDpU.mjs";
let o;
const r = async () => typeof window > "u" ? !1 : (o === void 0 && (o = new Promise((t) => {
  const n = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js", e = new XMLHttpRequest();
  e.timeout = 1e3, e.addEventListener("readystatechange", function() {
    e.readyState === XMLHttpRequest.DONE && t(e.status === 0 || e.responseURL !== n);
  }), e.open("HEAD", n, !0), e.send(null);
})), o);
function c(t, n) {
  return (/* @__PURE__ */ new Set(["0", "1"])).has(n) ? t : `${t}-${n}`;
}
let s;
async function p(t) {
  return s !== void 0 || (s = await r() ? Promise.resolve(void 0) : new Promise((e) => {
    setTimeout(() => {
      e(void 0);
    }, 5e3), a("get", t, "client_id", (i) => e(i));
  })), s;
}
export {
  c,
  r as d,
  p as g
};
//# sourceMappingURL=index-B2c8icUA.mjs.map
